

import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class VenueMaster extends EntityDto implements IEntityDto {
 Venue_Id: string;
 Venuetype_Id: string;
 VenueName: string;
 VenuetypeName: string;
 VenueAddress:string;
 Phone:String;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;
  DisplayValue: number;
  FacilityManager_Id: string;
  FacilityManagerName:string;

  constructor() {
    super();
    this.Venue_Id = '00000000-0000-0000-0000-000000000000';
    this.VenuetypeName = '';
    this.VenueName = '';
    this.Venuetype_Id= "";
    this.VenueAddress=''
    this.Phone=''
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.DisplayValue=0;
    this. FacilityManager_Id="";
    this.FacilityManagerName="";
    
    this.EntityMetaData = [
    
    //  { FieldName: 'Venue_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Venue  is required' },
     { FieldName: 'VenueName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Venue Name is required' },     
     { FieldName: 'VenueAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
    { FieldName: 'Venuetype_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Venue type is required' }
    
    ];
  }
}